// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"d2a5e5df","160":"0d984008","208":"631928ce","293":"85032427","516":"d9c83c89","519":"3a69dc1e","917":"0fdf1e55","946":"da3d13f7"}[chunkId] + ".chunk.js";
};